export const getAnioDefault = (): string => {
    if (typeof window === 'undefined') {
        return new Date().getFullYear().toString();
    }

    const anioDefault = new URLSearchParams(window.location.search).get('aniodefault');
    return anioDefault && anioDefault.trim() !== ""
        ? anioDefault.trim()
        : new Date().getFullYear().toString();
};